<select
  #selectElement
  id="country-select"
  class="form-control select"
  [value]="value"
  (change)="onValueChange(selectElement.value)"
  (focus)="onFocus()"
  (blur)="onBlur()"
  [class.label-top]="hasValue || isFocused">
  <option disabled hidden></option>
  <option *ngFor="let country of sortedCountries" [value]="country" [selected]="country === value">
    {{ country | country | async }}
  </option>
</select>
